document.addEventListener("DOMContentLoaded", function() {

    // Form validation
    // ===============
    const form = document.querySelector('[data-form-validate]');

    if (typeof Pristine === 'undefined' || !form)
        return;

    const validationConfig = {
        classTo: 'form-group',
        errorClass: 'has-error',
        successClass: 'is-valid',
        errorTextParent: 'form-group',
        errorTextTag: 'div',
        errorTextClass: 'errorMessage'
    }

    Pristine.addValidator("phone", function (phone) {
        let trimmedPhone = phone.replace('-', '').replace(' ', '').replace('+', '');
        return !isNaN(trimmedPhone);
    }, "Telefonní číslo není ve správném formátu.");

    Pristine.addMessages("cs", {
        required: "Toto pole je povinné.",
        email: "Toto pole neobsahuje validní e-mailovou adresu.",
        number: "Toto pole neobsahuje validní číslo.",
        integer: "Toto pole neobsahuje validní celé číslo.",
        url: "Toto pole neobsahuje validní URl adresu.",
        tel: "Toto pole neobsahuje validní telefonní číslo.",
        maxlength: "Text tohoto pole překročil délku ${1}.",
        minlength: "Text tohoto pole musí mít délku alespoň ${1}.",
        min: "Toto pole musí mít hodnotu alespoň ${1}.",
        max: "Toto pole může mít hodnotu nejvýše ${1}.",
        pattern: "Toto pole neobsahuje potřebný formát.",
        equals: "Tyto dvě pole se neshodují.",
    });

    Pristine.addMessages("sk", {
        required: "Toto pole je povinné.",
        email: "Toto pole neobsahuje platnú e-mailovú adresu.",
        number: "Toto pole neobsahuje platné číslo.",
        integer: "Toto pole neobsahuje platné celé číslo.",
        url: "Toto pole neobsahuje platnú URL adresu.",
        tel: "Toto pole neobsahuje platné telefónne číslo.",
        maxlength: "Text tohto poľa presiahol dĺžku ${1}.",
        minlength: "Text tohto poľa musí mať dĺžku aspoň ${1}.",
        min: "Toto pole musí mať hodnotu aspoň ${1}.",
        max: "Toto pole môže mať hodnotu najviac ${1}.",
        pattern: "Toto pole neobsahuje požadovaný formát.",
        equals: "Tieto dve polia sa nezhodujú.",
    });

    const htmlLang = document.querySelector('html').getAttribute('lang') || 'cs';
    Pristine.setLocale(htmlLang);
    let pristine = new Pristine(form, validationConfig);

    form.addEventListener('submit', (e) => {
        let isValid = pristine.validate();

        // extra validace jen na required selecty
        document.querySelectorAll("select[required]").forEach(select => {
            if (select) {
                isValid = pristine.validate(select) && isValid;
            }
        });

        if (!isValid) {
            e.preventDefault();
        } else {
            let button=document.querySelector("[data-wait-for-response]");
            if (typeof button==="undefined"||button===null) {
                return
            }
            button.classList.add("waitForResponse");
        }

    });
});
const dataMaxSize = () => {
    const fileList = document.querySelectorAll("[data-max-size]");
    for (let i = 0; i < fileList.length; i++) {
        const form = fileList[i].closest("form");
        fileList[i].addEventListener('change', (ev) => {
            form.querySelector('[data-file-alert]')?.remove();
            const fileListArr = Array.from(fileList[i].files);
            let files = [];
            for (var x in fileListArr) {
                if (!(fileListArr[x].name != "item" && typeof fileListArr[x].name != "undefined" && fileListArr[x].size <= fileList[i].getAttribute('data-max-size'))) {
                    files.push(fileListArr[x]);
                    fileListArr.splice(x, 1);
                }
            }
            if (files.length > 0) {
                let alertFiles = '';
                files.forEach((val, i, array) => {
                    alertFiles = alertFiles + val.name;
                    if (i < (array.length - 1)) {
                        alertFiles = alertFiles + ', ';
                    }
                });
                form.innerHTML = '<div class="alert alert-danger" data-file-alert>Soubor ' + alertFiles + ' překročil maximální povolenou velikost a byl odebrán</div>' + form.innerHTML;
                dataMaxSize();
            }
        });
    }
}
document.addEventListener("DOMContentLoaded", () => {
    dataMaxSize();
})